import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "markered-path",
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hover = true)),
    onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.hover = false))
  }, [
    _createVNode("canvas", {
      ref: "canvasElement",
      height: _ctx.height,
      width: _ctx.width
    }, null, 8, ["height", "width"])
  ], 32))
}